import OrderPageHeader from "./page-header";
import OrderStats from "@/app/shared/orders/shipment-stats";
import OrderListTable from "@/app/shared/orders/list/table";
import { fetchOrders } from "@/server/api-services";
import { Order, OrderStatus } from "@/types";
import { useState, useEffect } from "react";
import CargoPallet from "@/components/icons/cargo-pallet";
import Containers from "@/components/icons/containers";
import MoneyInHand from "@/components/icons/money-in-hand";
import ShipWithContainer from "@/components/icons/ship-with-container";
import ShippingBox from "@/components/icons/shipping-box";


export default function OrderListPage() {
    const [orders, setOrders] = useState<Order[]>([]);

    useEffect(() => {
        loadOrders();
    }, []);

    async function loadOrders() {
        const response = await fetchOrders();

        if (response.statusCode !== 200) {
            return;
        }

        var data = response.data as Order[];

        data = data.map(order => ({
            ...order,
            status: OrderStatus[order.status as keyof typeof OrderStatus]
        }));

        setOrders(data);
    }

    const refresh = () => loadOrders();

    const data = [
        {
            id: 1,
            count: orders.length,
            icon: <ShipWithContainer />,
            label: "Orders",
        },
        {
            id: 2,
            count: orders.filter((order) => order.status === OrderStatus.Delivered).length,
            icon: <ShippingBox />,
            label: "Delivered",
        },
        {
            id: 3,
            count: orders.filter((order) => order.status === OrderStatus.InTransit).length,
            icon: <CargoPallet />,
            label: "On Transit",
        },
        {
            id: 4,
            count: orders.filter((order) => order.status === OrderStatus.Requested).length,
            icon: <MoneyInHand />,
            label: "Requested",
        },
        {
            id: 4,
            count: orders.filter((order) => order.status === OrderStatus.Processing).length,
            icon: <Containers />,
            label: "Processing",
        },
        // {
        //     id: 5,
        //     count: orders.filter((order) => order.status === OrderStatus.Cancelled).length,
        //     icon: <Containers />,
        //     label: "Cancelled",
        // },
    ];

    return (
        <>
            <OrderPageHeader orders={orders.map(order => ({...order, product : { ...order.product, ImagePath: undefined }}))} />
            <div className="flex flex-col gap-10">
            <OrderStats data={data} />
            <OrderListTable orders={orders} refresh={refresh} />
            </div>
        </>
    );
}
